function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "#FEFEFE"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.205 13.5c0 7.3 5.917 13.217 13.217 13.217 4.892 0 9.16-2.659 11.445-6.609l-8.177-4.721a3.772 3.772 0 01-3.268 1.89 3.777 3.777 0 010-7.553V.283C6.122.283.205 6.2.205 13.5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.194 10.168l4.433-8.338A13.145 13.145 0 0013.422.283v9.44c.64 0 1.243.163 1.772.445",
  opacity: 0.6
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.69 11.613l8.177-4.72a13.274 13.274 0 00-1.627-2.234l-7.015 6.317c.176.196.332.408.465.637",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.225 10.976L23.24 4.66a13.273 13.273 0 00-3.613-2.829l-4.433 8.338c.39.208.738.482 1.03.808",
  opacity: 0.4
}));

function SvgLogowhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27"
  }, props), _ref);
}

export default SvgLogowhite;